import * as devisConf from '@/configuration/devisConf';
import { getAllRenouvellement } from '@/api/commande/index';
import transformRenouvellement from '@/services/devisCommandes/filters/renouvellementServerTableDataTransformer';
import trierParNomCommercial from '@/services/devisCommandes/trierParNomCommercial';
import genererCriteresRechercheRenouvellementCommande
  from '@/services/commande/criteresRecherche/genererCriteresRechercheRenouvellementCommande';
import * as allTypes from '../mutation-type';
import * as types from './renouvellementCommande-mutation-type';

function initialState() {
  return {
    renouvellementCommande: [],
    totalRenouvellement: 0,
    lastDataFromLoad: {},
    criteresRecherche: genererCriteresRechercheRenouvellementCommande(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_TOTAL_RENOUVELLEMENT](state, totalRenouvellement) {
    state.totalRenouvellement = totalRenouvellement;
  },
  [types.SET_LASTDATAFROMLOAD](state, lastData) {
    state.lastDataFromLoad = lastData;
  },
  [types.SET_RENOUVELLEMENT](state, renouvellementCommande) {
    state.renouvellementCommande = renouvellementCommande;
  },
};

const actions = {
  async loadRenouvellementCommandes({ commit }, data) {
    commit(types.SET_LASTDATAFROMLOAD, data);
    const response = await getAllRenouvellement(data);
    response.data.result.items.forEach((commande) => {
      const etat = devisConf.DEVIS_COMMANDE_ETAT.find((el) => {
        return el.code === commande.etat;
      });
      if (etat) {
        commande.etatLibelle = etat.libelle;
      }
      devisConf.LISTE_COMMERCIAL.forEach((el) => {
        if (commande.commercialId === el.id) {
          commande.nomCommercial = el.nom;
        }
      });
      commande.selected = false;
      const annonceurs = commande.intervenants.filter(intervenant => intervenant.annonceur);
      trierParNomCommercial(annonceurs);
      commande.listeAnnonceurs = annonceurs;
      const payeurs = commande.intervenants.filter(intervenant => intervenant.payeur);
      trierParNomCommercial(payeurs);
      commande.listePayeurs = payeurs;
    });
    commit(types.SET_TOTAL_RENOUVELLEMENT, response.data.result.totalCount);
    commit(types.SET_RENOUVELLEMENT, response.data.result.items);
    return {};
  },
};

const getters = {
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  totalRenouvellementCommande: state => {
    return state.totalRenouvellement;
  },
  renouvellementCommande: state => {
    return state.renouvellementCommande;
  },
  lastDataFromLoad: state => {
    return transformRenouvellement(state.lastDataFromLoad);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
